import React, { useState, useEffect } from 'react'
import { Input } from 'antd'
import './index.less'

export const InputNumber = ({
  value = '',
  onChange,
  min,
  max,
  maxLength = 25,
  ...otherProps
}) => {
  const [val, setVal] = useState(value)
  useEffect(() => {
    setVal(value)
  }, [value])
  const _onChange = (e) => {
    const _val = e.target.value === '' ? null : Number(e.target.value.replace(/\D/g, ''))
    if ((min || min === 0) && max) {
      if (_val >= min && _val <= max) {
        setVal(_val)
        onChange?.(_val)
      }
    } else {
      setVal(_val)
      onChange?.(_val)
    }
  }
  return <Input value={val} onChange={_onChange} maxLength={maxLength} {...otherProps} />
}
